export default __webpack_public_path__ + "static/media/example-email.34300f66.png";